import React, { type ReactElement, useState } from 'react'
import '../renderer/PageShell.css'
import { ChakraProvider } from '@chakra-ui/react'
import theme from '../theme'
import Navigation from '../components/Navigation'
import '@fontsource-variable/inter'
import CookieConsent from '../renderer/CookieConsent'
import { usePageContext } from 'vike-react/usePageContext'
import { RoomSettingsContext } from './+RoomSettingsContext'

import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://7a82b4a104c07c07761fd29a2b6e5171@o4508569819414528.ingest.us.sentry.io/4508569829769216',
  integrations: []
})

const Layout = ({
  children
}: {
  children: React.ReactNode
}): React.ReactNode => {
  const [roomSettings, setRoomSettings] = useState<any>(null)
  const [showIntroModal, setShowIntroModal] = useState<boolean>(false)
  let hasSidebar = true
  const pageContext = usePageContext()
  switch (pageContext.urlPathname) {
    case '/':
    case '/privacy':
    case '/client':
    case '/join':
      hasSidebar = false
      break
    default:
      if (pageContext.urlPathname.includes('/blog')) {
        hasSidebar = false
      }
  }

  return (
    <ChakraProvider theme={theme}>
      <RoomSettingsContext.Provider
        value={{
          roomSettings,
          setRoomSettings,
          showIntroModal,
          setShowIntroModal
        }}
      >
        <Inner>
          <Navigation hasSidebar={hasSidebar} />
          <Content>{children}</Content>
          <svg width="0" height="0">
            <filter
              id="blur-and-scale"
              y="-100%"
              x="-100%"
              width="400%"
              height="400%"
            >
              <feGaussianBlur
                in="SourceGraphic"
                stdDeviation="10"
                result="blurred"
              />
              <feColorMatrix
                type="saturate"
                in="blurred"
                result="saturated"
                values="3"
              />
              <feColorMatrix type="hueRotate" in="saturated" values="5" />
              <feComposite in="SourceGraphic" operator="over" />
            </filter>
          </svg>
          <CookieConsent />
        </Inner>
      </RoomSettingsContext.Provider>
    </ChakraProvider>
  )
}

function Inner({ children }: { children: React.ReactNode }): ReactElement {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto'
      }}
    >
      {children}
    </div>
  )
}

function Content({ children }: { children: React.ReactNode }): ReactElement {
  return (
    <div
      id="content"
      style={{
        padding: '0 0px 0',
        display: 'block',
        minHeight: 'calc(100vh - 59.5px)',
        position: 'relative'
      }}
    >
      {children}
    </div>
  )
}
export { Layout }
